import React from 'react';
import PropTypes from 'prop-types';
import './FormRadio.scss';

// FIXME checked={props.checked} is what causes the warning about controlled vs uncontrolled component.
const FormRadio = props =>
  <span className="relative">
    <input
      className="form-radio-input"
      id={props.id}
      name={props.name}
      type="radio"
      {...Object.assign({}, props.input, { value: props.id })}
      checked={props.checked}
      disabled={props.disabled}
    />
    <label
      className={`form-radio-label ${props.autotestClass}`}
      htmlFor={props.id}
    >{props.label}</label>
  </span>
;

FormRadio.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  autotestClass: PropTypes.string,
  input: PropTypes.object,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};

export default FormRadio;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormRadio/FormRadio.js
 **/